export const objectHref = (objectId: string, clientObjectId?: string) =>
  objectId === clientObjectId ? '/clients' : `/custom-objects/${objectId}`;

export const filterGroupHref = (
  id: string,
  objectId: string,
  clientObjectId?: string
) => `${objectHref(objectId, clientObjectId)}?group=${id}&filterOpen=true`;

export const agenticWorkflowHref = (id: string) => `/agentic-workflow/${id}`;

export const dashboardHref = (id: string) => `/dashboard/${id}`;

export const homepageHref = (id: string) => `/home/${id}`;

export const smartConnectorHref = (id: string) =>
  `/smartconnectors/${id}/settings`;

export const toolbarTemplateHref = (id: string) =>
  `/account/toolbar/templates/edit/${id}`;
